<template>
  <transition name="fade">
    <div v-if="show" class="dark-overlay intrusive-help h-v-centerer" @click="hideMessage(false)">
      <div class="message" @click.stop="">
        <img :src="iaHelp" class="ia-head" alt="">
        <div class="text" v-html="displayedText" />
        <Checkbox v-model="dontAskAgain" :title="$t('message.DONT_ASK_AGAIN')" />
        <button class="action-btn" @click="hideMessage(true)">
          {{ $t('message.YES') }}
        </button>
        <button class="action-btn gray" @click="hideMessage(false)">
          {{ dontAskAgain ? $t('message.NO') : $t('message.MAYBE_LATER') }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * Displays a modal to allow user to ask for help on this page.
 */

// Components
import Checkbox from '@/components/checkbox.vue';
// Utils
import { LSK_HIDE_PAGE_HELP } from '@/utils/constants';

const iaHelp = require('@/assets/img/ia-help.png');

export default {
  name: 'IntrusiveHelp',

  components: {
    Checkbox,
  },

  props: {
    text: {
      type: String,
      default: null,
    },
    helpKey: {
      type: String,
      required:true,
    },
    displayable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      iaHelp,
      show: false,
      dontAskAgain: false,
    };
  },

  computed: {
    displayedText() {
      return this.text || this.$t('help.NEED_HELP');
    },
    localStorageKey() {
      return `${LSK_HIDE_PAGE_HELP}${this.helpKey}`;
    },
  },

  watch: {
    displayable() {
      this.checkDisplay();
    },
  },

  created() {
    this.checkDisplay();
  },

  methods: {
    /** Check if the modal should be displayed using localStorage */
    checkDisplay() {
      // Get value from localStorage
      if (this.displayable) {
        this.show = !(window.localStorage.getItem(this.localStorageKey) === 'true');
      } else {
        this.show = false;
      }
    },
    /** User decided to hide the modal, check for 'dont ask again' */
    hideMessage(showHelp) {
      this.show = false;
      if (this.dontAskAgain) {
        window.localStorage.setItem(this.localStorageKey, 'true');
      } else {
        window.localStorage.removeItem(this.localStorageKey);
      }

      if (showHelp) {
        this.$emit('triggerComponentHelp');
      }
    },
  },
};
</script>>

<style lang="scss">
@import "@/assets/scss/vars.scss";



.intrusive-help {
  .message {
    background: white;
    border-radius: 20px;
    padding: 2em 2em 1.5em 2em;
    color: #585858;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: column;

    .text {
      font-weight: 600;
      line-height: 1.6em;
    }
    .ia-head {
      display: block;
      height: 3em;
      width: 3em;
      background: #ffffff;
      border-radius: 2000px;
      box-sizing: border-box;
      position: absolute;
      left: 50%;
      top: 0px;
      transform: translate(-50%, -50%);
    }
  }

  button, .checkbox {
    margin-top: 0.8em;
  }
}

</style>
